import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: null,
    loginForgotParams: null,
    isSuccess: null,
    error: "",
  },
  action
) {
  switch (action.type) {
    case homeConstants.LOGIN_FORGOT_PASSWORD_REQUEST:
      return {
        ...state,
        isSuccess: null,
        isProgress: true,
      };
    case homeConstants.LOGIN_FORGOT_PASSWORD_SUCCESS:
      return {
        data: action.response,
        isSuccess: action.response.success,
        loginForgotParams: action.params,
        isProgress: false,
      };
    case homeConstants.LOGIN_FORGOT_PASSWORD_FAILURE:
      return {
        data: null,
        error: action.error,
        isSuccess: null,
        isProgress: false,
      };
    case homeConstants.RESET_LOGIN_FORGOT_PASSWORD_STATUS:
      return {
        ...state,
        isSuccess: null,
        isProgress: false,
      };
    default:
      return state;
  }
}
